module.exports = __webpack_public_path__ + "img/4_08.29b2e5b0.jpg";